import module from 'finanzas/module.js'

const schema = {
  meses: 'number',
  tasa: 'number',
}

function FinanzasEmpleadoprestamosService ($http) {
  this.getEmpleados = function (buscar) {
    return $http.get('/kendu/finanzas/empleadoprestamos/empleados', {
      params: {
        buscar: buscar,
      },
    })
  }

  this.getTasas = function () {
    return $http.get('/kendu/finanzas/empleadoprestamos/tasas', {
      schema: schema,
    })
  }
}

module.service('FinanzasEmpleadoprestamos', FinanzasEmpleadoprestamosService)



// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/services/FinanzasEmpleadoprestamos.js